import { useMediaQuery } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Icons from "../../../../Config/Images";
import { addToCartAPI } from "../../../../Store/Action/cartAction";
import { getLoggedInUserDetailsAPI } from "../../../../Store/Action/UserAction";
import {
  addWishlistAPI,
  getWishlistAPI,
  removeWishlistAPI,
} from "../../../../Store/Action/wishlistAction";
import DeleteModal from "../../Auth/MyAccount/CustomModals/DeleteModal";
import CustomImageComponent from "../../CustomComponents/CustomImageComponent";
import "./styles.css";
import { triggerCartChange } from "../../../../Store/Slice/popupTriggerSlice";
import { addToCart } from "../../../../Store/Slice/cartSlice";
import VariantSelectionPopup from "../../CustomComponents/VariantSelectionPopup";
import { getProductDetailsAPI } from "../../../../Store/Action/productAction";

const WishlistCardSection = ({
  image,
  title,
  netWeight,
  wastage,
  fine,
  product,
  onGetWishlistProduct,
  isWishlistVisited = false,
}) => {
  const isWastageEnabled = useSelector(
    (state) => state.wastage.isWastageEnabled,
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  // const [isWastageEnabled, SetIsWastageEnabled] = useState(true);
  const [cartData, setCartData] = useState([]);
  const [selectedWishlistId, setSelectedWishlistId] = useState([]);
  const [isDeleteCart, setIsDeleteCart] = useState(false);
  const [userRole, setUserRole] = useState("");
  const [openVariantPopup, setOpenVariantPopup] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const is400SmallScreen = useMediaQuery("(max-width:450px)");

  const imageHeight = is400SmallScreen
    ? "190px"
    : isSmallScreen
      ? "216px"
      : "276px";
  const cardHeight = is400SmallScreen
    ? "185px"
    : isSmallScreen
      ? "200px"
      : "276px";

  const handleProductClick = () => {
    navigate(`/productDetail/${product.product_id}`, {
      state: { productId: product.product_id },
    });
  };

  useEffect(() => {
    dispatch(
      getLoggedInUserDetailsAPI({}, (result) => {
        setUserRole(result?.data?.[0]?.user_role_name);

        const booleanValue =
          result?.data?.[0]?.user_generic_data_value?.[0]
            ?.user_generic_data_boolean_value;

        // if (typeof booleanValue === "boolean") {
        //   SetIsWastageEnabled(booleanValue);
        // } else if (booleanValue === 0 || booleanValue === 1) {
        //   SetIsWastageEnabled(booleanValue === 1);
        // } else {
        // }
      }),
    );
  }, [dispatch]);
  const removeWishlist = (e, product) => {
    e.stopPropagation();
    const reqBody = {
      wishlist_id: product?.wishlist_id,
      flag_deleted: true,
    };
    dispatch(
      removeWishlistAPI(reqBody, (result) => {
        if (result?.status) {
          setIsDeleteCart(false);
          onGetWishlistProduct();
          // toast.success(result?.data?.message);
        } else {
          // toast.error(
          //   result?.error?.message || "Failed to remove item from wishlist."
          // );
        }
      }),
    );
  };

  const onAddToCartClick = (e, product) => {
    e.stopPropagation();
    if (
      product?.product_category_type_name?.toLowerCase() == "per pc product"
    ) {
      let currentQty = product?.min_quantity;

      const cartData = {
        product_id: product.product_id,
        quantity: currentQty,
        flag_move_to_cart: true,
      };
      dispatch(
        addToCartAPI(cartData, (result) => {
          if (result?.status) {
            // toast.success(result?.message?.message);
            onGetWishlistProduct();
          } else {
            toast.error(result?.error?.message);
          }
        }),
      );
    } else {
      dispatch(
        getProductDetailsAPI({ product_id: product?.product_id }, (result) => {
          setOpenVariantPopup(true);
          setSelectedProduct(result.data[0]);
        }),
      );
    }
  };

  const handlePreOrderClick = (e, product) => {
    e.stopPropagation();
    // handleVariantPopup(e, product, "preorder");
    const reqData = {
      product_id: product.product_id,
      flag_pre_order: true,
      // pre_order_weight: data.pre_order_weight,
    };

    dispatch(
      addWishlistAPI(reqData, (result) => {
        if (result?.data?.status) {
          toast.success(result?.data?.message?.message || "Pre-order added");
          onGetWishlistProduct();
        } else {
          toast.error(
            result?.data?.error?.message || "Failed to add pre-order",
          );
        }
      }),
    );
  };
  useEffect(() => {
    dispatch(
      getWishlistAPI({}, (result) => {
        setCartData(result);
      }),
    );
  }, [dispatch]);

  const onRemoveCart = useCallback((e, wishlistId) => {
    e.stopPropagation();
    setSelectedWishlistId(wishlistId);
    setIsDeleteCart(true);
  }, []);

  const handleButtonClick = (e) => {
    if (product?.product_status_name === "Out of stock") {
      handlePreOrderClick(e, product);
    } else {
      onAddToCartClick(e, product);
    }
  };

  return (
    <>
      <Card
        onClick={() => handleProductClick(product.product_id)}
        className="cardMainContainer"
      >
        <div>
          {/* <div style={styles.ratingContainer}>
          <p style={styles.lightBlackText}>{product?.overall_rating || 0}</p>
          <img src={Icons.ratingIcon} style={styles.ratingIcon} alt="" />
          <div style={styles.separator} />
          <p style={styles.totalRatingText}>
            {product?.total_ratings_of_product || 0}
          </p>
        </div> */}

          <div style={{ height: cardHeight }} className="img-upper-div">
            <CustomImageComponent
              src={image}
              width="100%"
              height={imageHeight}
            />
            {product?.product_status_name === "Out of stock" && (
              <div className="out-of-stock-label">Out of Stock</div>
            )}

            {/* <div className="ratingContainer">
              <p className="lightBlackText">{product?.overall_rating }</p>
              <img src={Icons.ratingIcon} className="ratingIcon" alt="" />
              <div className="separator" />
              <p className="totalRatingText">
                {product?.total_ratings_of_product}
              </p>
            </div> */}
          </div>

          <CardContent style={{ padding: "12px" }}>
            <div
              style={{
                // minHeight: "168px",
                minHeight: "150px",
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "column",
                textAlign: "left",
                // backgroundColor:"red"
              }}
            >
              <div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "10px",
                  }}
                >
                  <div className="prod-name-in-wishlist truncate-text-wishlist-title">
                    {/* {`${title || ""} ( ${product?.product_stamp_value || ""}, ${
                      product?.product_melting_value || ""
                    } )`} */}
                    {product?.product_name}
                  </div>
                  <img
                    // style={styles.deleteIcon}
                    className="deleteIcon"
                    src={Icons.trashIcon}
                    alt="Add to favorites"
                    onClick={(e) => onRemoveCart(e, product?.wishlist_id)}
                  />
                </div>
                {product?.product_category_type_name?.toLowerCase() ===
                "product" ? (
                  <>
                    <div className="prod-details-in-wishlist">
                      Net weight: {product?.product_avg_net_weight} g
                    </div>
                    <div className="bottomSectionStyle">
                      {isWastageEnabled && product?.mode_name === "Wastage" && (
                        <>
                          <div className="prod-details-in-wishlist">
                            Wastage : {wastage}
                          </div>
                          <div
                            style={{
                              height: "15px",
                              width: "1px",
                              backgroundColor: "#727272",
                            }}
                          />
                        </>
                      )}
                      <div className="prod-details-in-wishlist">
                        {/* Per pcs fine: {fine} gm */}
                        Stamp : {product?.product_stamp_value} (
                        {product?.product_melting_value})
                      </div>
                    </div>
                    <div
                      className="bottomSectionStyle"
                      style={{ marginTop: "6px", minHeight: "20px" }}
                    >
                      {product?.is_labour_enabled && (
                        <div className="prod-details-in-wishlist">
                          Labour
                          {product?.labour_type_code
                            ? ` (${product.labour_type_code})`
                            : ""}{" "}
                          : {product?.product_labour || "-"}
                        </div>
                      )}
                    </div>
                  </>
                ) : (
                  <>
                    <div className="prod-details-in-wishlist">
                      Code: {product?.product_code}
                    </div>
                    <div className="bottomSectionStyle">
                      <div className="prod-details-in-wishlist">
                        Per pc rate : {product?.product_per_pc_rate}
                      </div>
                      <div
                        style={{
                          height: "15px",
                          width: "1px",
                          backgroundColor: "#727272",
                        }}
                      />
                      <div className="prod-details-in-wishlist">
                        Category : {product?.product_category_name}
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div>
                <div style={{ marginTop: "10px" }}>
                  <button
                    onClick={handleButtonClick}
                    className="btnViewStyle"
                    onMouseOver={(e) =>
                      (e.target.style.backgroundColor = "#c9b38b")
                    }
                    onMouseOut={(e) =>
                      (e.target.style.backgroundColor = "#f4e2c7")
                    }
                    disabled={product?.flag_pre_order}
                  >
                    {isWishlistVisited
                      ? product?.product_status_name === "Out of stock"
                        ? "Pre Order"
                        : "Move to Cart"
                      : "Add to Cart"}
                  </button>
                </div>
              </div>
            </div>
          </CardContent>
        </div>
      </Card>
      {isDeleteCart && (
        <DeleteModal
          onClose={() => setIsDeleteCart(false)}
          onDelete={(e) => removeWishlist(e, product)}
        />
      )}
      {openVariantPopup && (
        <VariantSelectionPopup
          open={openVariantPopup}
          product={selectedProduct}
          onClose={() => setOpenVariantPopup(false)}
          onSubmit={(selectedIds) => {
            const request = {
              product_id: selectedProduct.product_id,
              product_variant_id: selectedIds,
              flag_move_to_cart: true,
            };

            dispatch(
              addToCartAPI(request, (result) => {
                if (result?.status) {
                  setOpenVariantPopup(false);
                  onGetWishlistProduct(); // Refresh cart after variant change
                }
              }),
            );
          }}
          mode="variant"
        />
      )}
    </>
  );
};

export default WishlistCardSection;
